<div class="auth-container">
  <div class="auth-form">
    <h2 class="form-header text-center">Kolla din e-post.</h2>

    <div>
      Vi har skickat en verifieringslänk till

      @if (email) {
        <strong>{{ email }}</strong>
      }
      @if (!email) {
        <span>din e-postadress</span>
        }.
        Kontrollera din inkorg och klicka på länken för att verifiera ditt konto.
      </div>

      <div class="mt-3">
        <p class="text-muted">Om du inte ser e-postmeddelandet, kontrollera din skräppostmapp.</p>
      </div>

      <div class="mt-3">
        <button class="btn btn-primary" (click)="goToLogin()">
          Gå till inloggning
        </button>
      </div>
    </div>
  </div>